<template>
  <div class="margin-y-3 margin-x-10">
    <h1 style="text-transform: uppercase; font-weight: 700; letter-spacing: 1px; font-size: 30px;" class="margin-y-4">Create a new campaign</h1>
    <campaign-form ref="campaignForm" :campaign="campaign">
      <template v-slot:action-buttons>
        <ladda-button :click="() => { return createCampaign('edit') }" class="btn btn-primary btn-md">Create & Add Requests</ladda-button>
        <ladda-button :click="() => { return createCampaign('drafts') }" class="btn btn-md">Save as draft</ladda-button>
      </template>
    </campaign-form>
  </div>
</template>
<script>
import CampaignForm from './CampaignForm'
import { http, notify } from 'utils'
export default {
  components: {CampaignForm},

  methods: {
    createCampaign (link) {
      if (this.$refs.campaignForm.$v.$invalid) {
        this.$refs.campaignForm.$v.$touch()
        return Promise.resolve()
      }
      return http.post(`campaigns/create`, this.campaign).then(response => {
        notify.success('Successfully saved campaign')
        if (link === 'drafts') {
          this.$router.push({ name: 'campaigns.index', params: { status: 'draft' } })
        }
        if (link === 'edit') {
          this.$router.push({ name: 'campaign.edit', params: { id: response.data.id } })
        }
      })
    }
  },

  data () {
    return {
      campaign: {
        name: '',
        start_date: null,
        end_date: null,
        description: ''
      }
    }
  }
}
</script>
